import axios from 'axios';
import { ROOT_API_URL } from "../api-config";

export const auth = {
    isAuthenticated,
    getUserToken,
    getAuthUserEmail,
    getAuthUser,
    removeToken,
    setToken,
    authHeader,
    getRoles,
    isInRole,
    login,
    getPermissions,
    getAuthUserId
};

function isAuthenticated() {
    var user = this.getAuthUser();
    return user ? true : false;
}

function getUserToken() {
    var user = this.getAuthUser();
    return user ? user.token : null;
}

function getAuthUserEmail() {
    var user = this.getAuthUser();
    return user ? user.email : '';
}
function getAuthUserId() {
    var user = this.getAuthUser();
    return user ? user.userId : '';
}
function getAuthUser() {
    try{
        const str = localStorage.getItem('authUser');
        if (str) {
            var authUser = JSON.parse(str);
            if (authUser && authUser.token && authUser.email) {
                //todo validate token from api;
                return authUser;
            }
        }
        this.removeToken();
        return null;
    }catch{
        this.removeToken();
        return null;
    }
}

function removeToken() {
    localStorage.removeItem('authUser');
    localStorage.removeItem('auth-user-details');
}

function setToken(authUser) {
    localStorage.setItem('authUser', JSON.stringify(authUser));
}

function getRoles() {
    var user = this.getAuthUser();
    return user && user.roles ? user.roles : [];
}
function getPermissions() {
    var user = this.getAuthUser();
    //console.log(user);
    return user && user.permissions ? user.permissions : [];
}


function isInRole(roleName){
    if (!roleName) return false;
    var user = this.getAuthUser();
    var roles = user && user.roles ? user.roles : [];;
    var role = roles.find(x => x.toUpperCase() === roleName.toUpperCase());
    return role ? true : false;
}

function authHeader() {
    let token = this.getUserToken();
    return token ? { 'Authorization': `Bearer ${token}`} : {};
}

function login(email, password){
    var url = `${ROOT_API_URL}/users/login`;
    return axios.post(url, { email: email, password: password }, {
        headers: { 'Content-Type': 'application/json' }
    });
}